import {listTags as list} from '@/domain/bem/services'
export default function (terms) {
    let filtros = encodeURI(`&sortBy=name&descending=false&search=${terms}`)
    return list(50, 1, filtros)
}
